import React, { useState } from 'react';
import { IStore, IUser, IUserEditRequest, UserClient, UserEditRequest, UserRole } from '../../../services/WebApiClient';
import { useClient } from '../../../util/useClient';

export function SingleUserEditor(props: {
    user: IUser;
    onChange: () => void;
    stores: IStore[] | undefined;
}) {

    const user = props.user;
    const [state, setState] = useState<IUserEditRequest>({
        id: user.id,
        email: user.email,
        name: user.name,
        password: null,
        username: user.username,
        userRole: user.userRole,
        storeId: user.storeId
    });
    const client = useClient(UserClient);


    function updateProp(changes: Partial<IUserEditRequest>) {
        setState({
            ...state,
            ...changes
        });
    }
    async function updateUser(evt: React.FormEvent) {
        evt.preventDefault();
        const request = {
            ...state,
            password: state.password === "" ? null : state.password
        };
        try {
            await client.editUser(new UserEditRequest(request));
        }
        finally {
            props.onChange();
        }
    }

    return (
        <div>
            <h4>User: {props.user.name}</h4>

            <form onSubmit={updateUser} >

                <div className="form-group">
                    <label htmlFor="u-username">Username</label>
                    <input id="u-username"
                        className="form-control"
                        value={state.username}
                        onChange={evt => updateProp({ username: evt.target.value })} />
                </div>

                <div className="form-group">
                    <label htmlFor="u-name">Name</label>
                    <input id="u-name"
                        className="form-control"
                        value={state.name}
                        onChange={evt => updateProp({ name: evt.target.value })} />
                </div>

                <div className="form-group">
                    <label htmlFor="u-email">Email</label>
                    <input id="u-email"
                        className="form-control"
                        value={state.email}
                        onChange={evt => updateProp({ email: evt.target.value })} />
                </div>

                <div className="form-group">
                    <label htmlFor="u-password">Password (leave blank for no change)</label>
                    <input id="u-password"
                        className="form-control"
                        value={state.password ?? ""}
                        onChange={evt => updateProp({ password: evt.target.value })} />
                </div>

                <div className="form-group">
                    <label htmlFor="u-userrole">User type</label>
                    <select className="form-control"
                        id="u-userrole"
                        value={state.userRole}
                        onChange={evt => updateProp({ userRole: parseInt(evt.target.value) })}
                    >
                        <option value={UserRole.StoreUser}>Store Manager</option>
                        <option value={UserRole.Admin}>TMK Admin</option>
                    </select>
                </div>

                <div className="form-group">
                    <label htmlFor="u-userstore">Store</label>
                    <select className="form-control"
                        id="u-userrole"
                        value={state.storeId ?? undefined}
                        onChange={evt => updateProp({ storeId: evt.target.value ? parseInt(evt.target.value) : null })}
                    >
                        <option value=""> -- </option>
                        {props.stores?.map(store => (
                            <option key={store.id} value={store.id}> {store.name} ({store.externalId}) </option>
                        ))
                        }
                    </select>
                </div>

                <button type="submit" className="btn btn-primary">Update </button>
            </form>
        </div>
    );
}
